import { Typography, styled } from "@mui/material";
import { useSnackbar } from "notistack";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CopyAltIcon } from "src/theme/overrides/CustomIcons";

interface OwnProps {
    uuid: string;
}

const UuidButton = styled("button")(({ theme }) => ({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    // background: "#f9fafb",
    backgroundColor: theme.palette.grey[100],
    border: "1px solid rgba(145, 158, 171, 0.24)",
    height: 32,
    padding: theme.spacing(0, 1.5),
    fontSize: theme.typography.pxToRem(16),
    borderRadius: 4,
    transition: theme.transitions.create("border-color"),
    "&:hover": {
        borderColor: "rgba(145, 158, 171, 0.72)",
    },
}));

const UuidCopyButton: FC<OwnProps> = ({ uuid }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    return (
        <UuidButton
            onClick={() => {
                navigator.clipboard.writeText(uuid);
                enqueueSnackbar(t("shared.uuidCopied"), { variant: "success" });
            }}
        >
            <Typography variant="body2">{uuid.slice(-8)}</Typography>
            <CopyAltIcon fontSize="inherit" sx={{ color: "text.secondary", ml: 1.25 }} />
        </UuidButton>
    );
};

export default UuidCopyButton;
